const digitsOnly = (value) => String(value || '').replace(/\D/g, '');

export const normalisePhoneNumber = (value, defaultCountryCode = '+27') => {
  const rawValue = String(value || '').trim();
  if (!rawValue) return '';

  const defaultDigits = digitsOnly(defaultCountryCode) || '27';

  if (rawValue.startsWith('+')) {
    return `+${digitsOnly(rawValue)}`;
  }

  if (rawValue.startsWith('00')) {
    return `+${digitsOnly(rawValue).replace(/^00/, '')}`;
  }

  const digits = digitsOnly(rawValue);
  if (!digits) return '';

  if (digits.startsWith(defaultDigits) && digits.length > defaultDigits.length) {
    return `+${digits}`;
  }

  return `+${defaultDigits}${digits.replace(/^0+/, '')}`;
};

export const phoneNumberForWhatsApp = (value, defaultCountryCode = '+27') => (
  digitsOnly(normalisePhoneNumber(value, defaultCountryCode))
);
